import React from "react";
import { Box, Typography, Card, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../../styles/styles.scss";
import {
  loaderContainerStyle,
  circularProgressStyle,
  pricelistContainerStyle,
  pricelistTitleText,
  pricelistCardStyle,
  pricelistCardImageStyle,
  pricelistCardRemoveIconStyle,
  pricelistCardOverlayStyle,
  managePricelistButtonStyle,
  noPricelistBoxStyle,
  noPricelistTextStyle,
  noPricelistTextDescriptionStyle,
  pricelistCardNameStyle,
  pricelistCardServicesStyle,
  pricelistCardContentStyle,
} from "../../styles/styles";
import { CircularProgress } from "@mui/material";

const MyPricelistsSection = (props) => {
  const {
    pricelists,
    pricelistsLength,
    handleManageClick,
    handleRemoveClick,
    loader,
  } = props;
  const { t, i18n } = useTranslation(["pricelist-search", "categories"]);
  // Use i18n's own direction lookup so this works for any RTL language
  // (Hebrew, Arabic, etc.), not just Hebrew.
  const isRtl = i18n.dir() === "rtl";

  return (
    <Box sx={pricelistContainerStyle}>
      <Typography sx={pricelistTitleText}>
        {t("my_pricelist")}{" "}
        <Typography as="span" sx={{ ...pricelistTitleText, fontWeight: 400 }}>
          ({pricelistsLength})
        </Typography>
      </Typography>

      <Box
        sx={{
          minHeight: "266px",
          display: "flex",
        }}
      >
        {loader ? (
          <Box sx={loaderContainerStyle}>
            <CircularProgress size={60} sx={circularProgressStyle} />
          </Box>
        ) : pricelistsLength > 0 ? (
          <Box sx={{ width: "100%" }}>
            <Swiper
              key={isRtl ? "rtl" : "ltr"}
              dir={isRtl ? "rtl" : "ltr"}
              modules={[Navigation]}
              slidesPerView="auto"
              spaceBetween={18}
              navigation={true}
              className="my-pricelists-swiper"
            >
              {pricelists.map((item) => (
                <SwiperSlide key={item.subcategory_id}>
                  <Card sx={pricelistCardStyle}>
                    <Box sx={pricelistCardImageStyle}>
                      <img
                        width="100%"
                        height="100%"
                        src={item.image_url || "/pricelist-icon.svg"}
                        alt={item.subcategory_name}
                      />
                      <Box
                        onClick={() => handleRemoveClick(item)}
                        sx={pricelistCardRemoveIconStyle}
                      >
                        <img
                          width="12px"
                          src="/icons/trash-icon.svg"
                          alt="trash-icon"
                        />
                      </Box>

                      {/* overlay */}
                      <Box sx={pricelistCardOverlayStyle} />
                    </Box>
                    <Box sx={pricelistCardContentStyle}>
                      <Typography sx={{ ...pricelistCardNameStyle, flex: 1 }}>
                        {t(item.subcategory_name, { ns: "categories" })}
                      </Typography>

                      <Typography sx={pricelistCardServicesStyle}>
                        {!item.priced_services && item.visit_price_relevant
                          ? item.is_draft && !item.has_visit_price_value
                            ? t("waiting_for_pricing")
                            : t("visit_price_active")
                          : item.priced_variants +
                            "/" +
                            item.total_variants +
                            " " +
                            t("active_services")}
                      </Typography>

                      <Button
                        variant="contained"
                        onClick={() => handleManageClick(item.subcategory_id)}
                        sx={managePricelistButtonStyle}
                      >
                        {t("manage_pricelist")}
                      </Button>
                    </Box>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        ) : (
          <Box sx={noPricelistBoxStyle}>
            <img
              objectFit="contain"
              width="41px"
              height="41px"
              src={"/icons/add-files-icons.svg"}
              alt="add-files-icons"
            />
            <Typography sx={noPricelistTextStyle}>
              {t("no_pricelist_yet")}
            </Typography>
            <Typography sx={noPricelistTextDescriptionStyle}>
              {t("no_pricelist_yet_description")}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MyPricelistsSection;
